//state
export var codPostalState = {
  codPostales: [],
  codPostal: {},
  status_propuesta: ""
};

//getters
export var codPostalGetters = {
  //funciones para optener informacion del state
  getCodPostales: state => state.codPostales
};

//actions
export var codPostalActions = {
  async getCodPostales({ commit }) {
    commit("codPostal_request");
    await this._vm.$http
      .get("/apache/rest_api/res.country.state.zip", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields:
            "['id', 'name','city_id','city_name','lng','lat',('state_id', ['id', 'name'])]"
        },
        params: {
          limit: 10
        }
      })
      .then(res => {
        var codPostales = res.data;
        commit("codPostal_success", codPostales);
        return res;
      })
      .catch(err => {
        commit("codPostal_error");
        return err;
      });
  },
  async getCodPostalesState({ commit }, state_id) {
    commit("codPostal_request");
    await this._vm.$http
      .get("/apache/rest_api/res.country.state.zip", {
        headers: {
          "X-Odoo-dbfilter": "apachev1",
          fields: "['id', 'name','city_id','city_name','lng','lat',('state_id', ['id', 'name'])]"
        },
        params: {
          limit: 250,
          args: `[["state_id", "=?", ${state_id}]]`
        }
      })
      .then(res => {
        var codPostales = res.data;
        commit("codPostal_success", codPostales);
        return res;
      })
      .catch(err => {
        commit("codPostal_error");
        return err;
      });
  },
  async newCodPostal({ commit, state }, codPostal) {
    commit("codPostal_request");
    var { name, idCity, cityName, longitud, latitud, idState } = codPostal;
    var formData = new FormData();
    //{name: "test", city_id: "test", city_name: "test", lng: "10", lat: "12", state_id: 448}
    var newCodPostal = `{'name':'${name}','city_id': '${idCity}','city_name':'${cityName}','lng':'${longitud}','lat':'${latitud}','state_id':${idState}}`;
    formData.append("data", newCodPostal);
    await this._vm.$http
      .post("/apache/rest_api/res.country.state.zip", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 201) {
          codPostal.id = res.data.id;
          codPostal.name = codPostal.name;
          codPostal.city_id = codPostal.idCity;
          codPostal.city_name = codPostal.cityName;
          codPostal.lat = codPostal.latitud;
          codPostal.lng = codPostal.longitud;
          codPostal.state_id = codPostal.idState;
          var codPostales = state.codPostales;
          codPostales.push(codPostal);
          commit("codPostal_success", codPostales);
          return codPostales;
        } else {
          commit("codPostal_error");
        }
      })
      .catch(err => {
        commit("codPostal_error");
        return err;
      });
  },
  async editCodPostal({ commit, state }, codPostal) {
    commit("codPostal_request");
    var { id, name, idCity, cityName, longitud, latitud, idState } = codPostal;
    var formData = new FormData();
    //{name: "test", city_id: "test", city_name: "test", lng: "10", lat: "12", state_id: 448}
    var newCodPostal = `{'name':'${name}','city_id': '${idCity}','city_name':'${cityName}','lng':'${longitud}','lat':'${latitud}','state_id':${idState}}`;
    formData.append("data", newCodPostal);
    await this._vm.$http
      .put("/apache/rest_api/res.country.state.zip", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          var index;
          codPostal.id = id;
          codPostal.name = codPostal.name;
          codPostal.city_id = codPostal.idCity;
          codPostal.city_name = codPostal.cityName;
          codPostal.lat = codPostal.latitud;
          codPostal.lng = codPostal.longitud;
          codPostal.state_id = codPostal.idState;
          var codPostales = state.codPostales;
          for (var i = 0; i < codPostales.length; i++) {
            if (codPostales[i].id == id) {
              index = i;
              codPostales[i] = codPostal;
              break;
            }
          }
          codPostales.splice(index, 1);
          codPostales.splice(index, 0, codPostal);
          commit("codPostal_success", codPostales);
          return codPostales;
        } else {
          commit("codPostal_error");
        }
      })
      .catch(err => {
        commit("codPostal_error");
        return err;
      });
  },
  async deleteCodPostal({ commit, state }, id) {
    commit("codPostal_request");
    await this._vm.$http
      .delete(`/apache/rest_api/res.country.state.zip/${id}`, {
        headers: {
          "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 200) {
          var index;
          var codPostales = state.codPostales;
          for (var i = 0; i < codPostales.length; i++) {
            if (codPostales[i].id == id) {
              index = i;
              break;
            }
          }
          codPostales.splice(index, 1);
          commit("codPostal_success", codPostales);

          return codPostales;
        } else {
          commit("codPostal_error");
        }
      })
      .catch(err => {
        commit("codPostal_error");
        return err;
      });
  },
  async deleteCodPostalUtility({ commit, state }, id) {
    commit("codPostal_request");
    var index;
    var codPostales = state.codPostales;
    for (var i = 0; i < codPostales.length; i++) {
      if (codPostales[i].id == id) {
        index = i;
        break;
      }
    }
    codPostales.splice(index, 1);
    commit("codPostal_success", codPostales);

    return codPostales;
  }
};

//mutations

export var codPostalMutations = {
  codPostal_request(state) {
    state.status_line = "loading";
  },
  codPostal_success(state, payload) {
    state.status_line = "success";
    state.codPostales = payload;
  },
  codPostal_error(state) {
    state.status_line = "error";
  }
};
